import React, { useState, useEffect } from 'react';

// import { useQuery } from 'react-query';

import Frame from './Frame';
import Timestamps from './Timestamps';
import DotsLoader from '../../../DotsLoader';

import classes from './styles.module.scss';
// import SectionService from '../../../../services/SectionService';

function isChromiumEngine() {
  if (
    navigator.userAgentData &&
    Array.isArray(navigator.userAgentData.brands)
  ) {
    return navigator.userAgentData.brands.some((b) => b.brand === 'Chromium');
  }
  // fallback if UA Client Hints isn’t supported
  return null;
}

const shouldIncreaseHeight = isChromiumEngine();

export default function Timeline({
  section,
  zoom,
  frameWidth,
  //  setFrameWidth,
  framesListRef,
  scrollWidth,
  setScrollLeft,
  frames,
  frameCount,
  isGenerating = false,
  generationError = null,
}) {
  const [frameNumbers, setFrameNumbers] = useState([]);
  const [showHangTight, setShowHangTight] = useState(false);
  const framesLength = frames?.length || 0;

  useEffect(() => {
    if (!isGenerating) {
      setShowHangTight(false);
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      setShowHangTight(true);
    }, 4000);

    return () => clearTimeout(timeoutId);
  }, [isGenerating]);

  useEffect(() => {
    const total = frameCount || framesLength || 0;
    if (total === 0) {
      setFrameNumbers([]);
      return;
    }
    const zoomFloat = zoom / 100;

    // number of frames to show
    const desired = Math.floor(total * zoomFloat);
    // clamp between 1 and total
    const count = Math.max(1, Math.min(total, desired));
    const step = total / count;
    const sampled = Array.from({ length: count }, (_, i) =>
      Math.floor(i * step)
    );
    setFrameNumbers(sampled);
  }, [frameCount, framesLength, zoom]);

  /*  const { data: frames } = useQuery({
    queryKey: ['sectionFrames', section.id],
    queryFn: () => SectionService.getSectionFrames(section.id),
    enabled: !!section.id && frameNumbers.length > 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  }); */

  // Measure frames width
  /* useEffect(() => {
    if (frames?.length > 0) {
      const img = new Image();
      img.src = frames[0].url;
      img.onload = () => {
        const uniformWidth = (img.naturalWidth / img.naturalHeight) * 65;
        setFrameWidth(Math.floor(uniformWidth));
      };
    }
  }, [frames, setFrameWidth]); */

  const renderTimelineContent = () => {
    if (generationError) {
      return (
        <div className={`${classes.timelineOverlay} ${classes.errorOverlay}`}>
          <span className={classes.timelineOverlayText}>{generationError}</span>
        </div>
      );
    }

    if (isGenerating) {
      return (
        <div className={classes.timelineOverlay}>
          <DotsLoader pink />
          <span className={classes.timelineOverlayText}>
            {showHangTight ? 'Still loading, hang tight...' : 'Loading video file...'}
          </span>
        </div>
      );
    }

    return (
      <div
        className={classes.scrollContainer}
        style={shouldIncreaseHeight ? { height: 115 } : null}
        onScroll={(event) => {
          setScrollLeft(event.target.scrollLeft);
        }}
      >
        <Timestamps section={section} scrollWidth={scrollWidth} />

        <ul className={classes.framesList} ref={framesListRef}>
          {frameNumbers.map((frameNumber) => {
            return (
              <Frame
                key={frameNumber}
                // frameUrl={frames?.[frameNumber]?.url}
                frameUrl={frames?.[frameNumber]}
                width={frameWidth}
              />
            );
          })}
        </ul>
      </div>
    );
  };

  return (
    <div className={classes.Timeline}>
      <div className={classes.timelineContainer}>
        {renderTimelineContent()}
      </div>
    </div>
  );
}
